import Root from './Root';
import Slide from './Slide';
import Title from './Title';
var Carousel = {
    Title: Title,
    Slider: Root,
    Slide: Slide,
};
export default Carousel;
